import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.workflow.fields.id'),
  },
  {
    name: 'icon',
    label: i18n('entities.workflow.fields.icon'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'active',
    label: i18n('entities.workflow.fields.active'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'name',
    label: i18n('entities.workflow.fields.name'),
  },
  {
    name: 'description',
    label: i18n('entities.workflow.fields.description'),
  },
  {
    name: 'flowSteps',
    label: i18n('entities.workflow.fields.flowSteps'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'color',
    label: i18n('entities.workflow.fields.color'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.workflow.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.workflow.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
